module.exports = __webpack_public_path__ + "img/5f35579.png";